/**
 *
 * @returns slug from url pathname that is needed for fetching data from UniversalAPI
 */
const getSlugFromPathname = (): string => {
  return window.location.pathname.split('/')[1];
};

export default getSlugFromPathname;
